import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Label from '../../Components/Label';
import Button from '../../Controls/Button';
import Icons from '../../Elements/Icons';
import { HiddenCheckbox } from '../CheckboxSwitcher';
export const CheckboxLockToggle = ({ checked, onChange }) => (_jsx(Button, { icon: true, children: _jsxs(Label, { type: 'inline-checkbox', children: [_jsx(HiddenCheckbox, { type: 'checkbox', checked: checked, onChange: onChange }), checked ? _jsx(Icons.Locked, {}) : _jsx(Icons.Unlocked, {})] }) }));
